"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_COVERAGE_REQUEST_EXAMPLE = exports.updateCoverageRequestSchema = void 0;
const zod_1 = require("zod");
exports.updateCoverageRequestSchema = zod_1.z.object({
    coverageId: zod_1.z.string().uuid(),
    expectedLockVersion: zod_1.z.number().int().nonnegative(),
    groupNumber: zod_1.z.string().optional(),
    cashlessEligible: zod_1.z.boolean().optional(),
    preAuthRequired: zod_1.z.boolean().optional(),
    validTo: zod_1.z.coerce.date().optional(),
    /** Insurance module (ADR-098): the plan the policy belongs to, and its sum insured in paise. */
    planId: zod_1.z.string().uuid().nullable().optional(),
    sumInsuredAmount: zod_1.z.number().int().min(0).nullable().optional(),
});
exports.UPDATE_COVERAGE_REQUEST_EXAMPLE = {
    coverageId: '44444444-4444-4444-4444-444444444444',
    expectedLockVersion: 1,
    cashlessEligible: true,
};
//# sourceMappingURL=coverage.request.js.map